import { put, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import { KnmRegistryTypeEnum } from 'APIPackage/KnmModule/enums/KnmRegistryTypeEnum';
import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';
import { addNoticeImportNotification } from 'CorePackage/NotificationModule/common/addNoticeImportNotification';
import {
  exportRegistryByType,
  fetchMspInfo,
  fetchOezInfo,
  fetchRegistryEgrip,
  fetchRegistryEgrul,
  fetchSpvInfo,
  fetchToserInfo,
} from 'APIPackage/KnmModule/services/knmRegistryApi';
import { IKnmRegistryItem } from 'APIPackage/KnmModule/interfaces/IKnmRegistryItem';

import { KnmRegistryActionsEnum } from '../enums/KnmRegistryActionsEnum';
import { knmRegistryExport, knmRegistryGetData, knmRegistrySetData } from '../actions/knmRegistryActions';

export function* watchKnmRegistrySaga() {
  yield takeEvery(KnmRegistryActionsEnum.KNM_REGISTRY_GET_DATA, knmRegistryGetDataSaga);
  yield takeEvery(KnmRegistryActionsEnum.KNM_REGISTRY_EXPORT, knmRegistryExportSaga);
}

function* knmRegistryGetDataSaga(action: ActionType<typeof knmRegistryGetData>) {
  const { id, type } = action.payload;
  let res: IKnmRegistryItem[] = [];

  function* funcTry() {
    switch (type.toUpperCase()) {
      case KnmRegistryTypeEnum.MSP: {
        res = yield fetchMspInfo(id);
        break;
      }
      case KnmRegistryTypeEnum.EGRIP: {
        res = yield fetchRegistryEgrip(Number(id));
        break;
      }
      case KnmRegistryTypeEnum.EGRUL: {
        res = yield fetchRegistryEgrul(Number(id));
        break;
      }
      case KnmRegistryTypeEnum.TOSER: {
        res = yield fetchToserInfo(id);
        break;
      }
      case KnmRegistryTypeEnum.OEZ: {
        res = yield fetchOezInfo(id);
        break;
      }
      case KnmRegistryTypeEnum.SPV: {
        res = yield fetchSpvInfo(id);
        break;
      }
      default: {
        break;
      }
    }
  }

  yield sagaWrapper({
    funcTry,
    *funcFinally() {
      yield put(knmRegistrySetData(res));
    },
  });
}

function* knmRegistryExportSaga(action: ActionType<typeof knmRegistryExport>) {
  function* funcTry() {
    const { id, registryType, format } = action.payload;

    const res: IExport = yield exportRegistryByType(id, registryType, format);

    yield put(addNoticeImportNotification(res.id));
  }

  yield sagaWrapper({
    funcTry,
  });
}
